$(function () {
  const magnificGallery = {
    init() {
      magnificGallery.create();
    },
    create() {
      const ele = $('[data-magnific-gallery]');
      if (ele.length == 0) return;

      const delegate = ele.data('delegate')
      ele.each(function() {
        $(this).magnificPopup({
          delegate,
          type: 'image',
          gallery: {
            enabled:true
          }
        });
      })
    },
  };

  magnificGallery.init();
});
